import {RoomState} from '../../../../../shared/RoomState'
import {UIManager} from '../UIManager'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {UIRoomUserList} from '../../../../shared/scripts/ui_html/room/UIRoomUserList'
import {RoomSessionClientState} from '../../../../../shared/RoomSessionClientState'

export class UIRoomUserListController extends UIRoomUserList {
    private readonly uiManager: UIManager
    private readonly header: HTMLHeadingElement

    constructor(uiManager: UIManager) {
        super(document.getElementById('scene_room_player_list') as HTMLDivElement)
        this.uiManager = uiManager
        this.header = document.getElementById('scene_room_left_header') as HTMLHeadingElement
    }

    update(newRoomState: RoomState) {
        this.updateHeaderView(newRoomState.getSessionCount(), newRoomState.gameSetting.maxPlayers)
        super.update(newRoomState)
    }

    private updateHeaderView(sessionCount: number, maxPlayers: number) {
        const newText = clientI18n.t('strings:roomPage.notifications.playerCount', {count: sessionCount, maxCount: maxPlayers})
        if(this.header.innerText != newText) this.header.innerText = newText
    }

    openColorWindowForPlayer(player: RoomSessionClientState | undefined): void {
        this.uiManager.room.colorSelector.openColorWindowForPlayer(player)
    }
    showUpdateUsernamePopup(): void {
        this.uiManager.header.profileController.showUpdateUsernamePopup()
    }
}
